import React from 'react';

const SvgArrows14 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 16" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M9.06 15.138a.5.5 0 0 1-.71 0l-.2-.2a.49.49 0 0 1-.15-.36v-3.58H.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H8v-3.58a.49.49 0 0 1 .15-.36l.2-.2a.5.5 0 0 1 .71 0l6.79 6.79a.48.48 0 0 1 0 .7zM2 6.998v2h7.5a.5.5 0 0 1 .5.5v1.88l3.38-3.38L10 4.618v1.88a.5.5 0 0 1-.5.5z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgArrows14 svgRef={ref} {...props} />);
export default ForwardRef;
